export default __webpack_public_path__ + "static/media/angular2.dffb7646.PNG";